import { useEffect, useRef, useState } from 'preact/hooks';
import { apiPatch, ApiError } from '../lib/api';
import './../styles/components/edit-popover.css';

type Props = {
  id: string;
  name: string;
  valueEur: number | null;
  onClose: () => void;
  onSaved: () => void;
};

export function EditNonTradablePopover({
  id,
  name,
  valueEur,
  onClose,
  onSaved,
}: Props) {
  const [value, setValue] = useState(valueEur != null ? String(valueEur) : '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  async function handleSubmit(e: Event) {
    e.preventDefault();
    if (saving) return;
    setError(null);

    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) {
      setError('Value must be zero or a positive number');
      return;
    }

    setSaving(true);
    try {
      await apiPatch(`/api/portfolio/non-tradable/${encodeURIComponent(id)}`, {
        value_eur: n,
      });
      onSaved();
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : 'Save failed';
      setError(msg || 'Save failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <dialog
      ref={dialogRef}
      class="edit-modal"
      onClose={onClose}
      onClick={(e) => {
        if (e.target === dialogRef.current) dialogRef.current?.close();
      }}
    >
      <form class="edit-pop" onSubmit={handleSubmit}>
        <h3 class="edit-pop-title">
          Edit value
          <span class="edit-pop-subtitle">{name}</span>
        </h3>
        <div class="edit-pop-row">
          <label class="edit-pop-label">Value (EUR)</label>
          <input
            class="edit-pop-input mono"
            type="number"
            step="any"
            min="0"
            value={value}
            onInput={(e) => setValue((e.target as HTMLInputElement).value)}
            disabled={saving}
          />
        </div>
        {error && <div class="edit-pop-error mono">{error}</div>}
        <div class="edit-pop-actions">
          <button
            type="button"
            class="edit-pop-btn edit-pop-btn-ghost"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button type="submit" class="edit-pop-btn edit-pop-btn-primary" disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </form>
    </dialog>
  );
}
